import type { FC } from 'react';
import React from 'react';

import ServiceCard from '../components/ServiceCard';
import '../components/ServiceCard.scss';
import useAppStore, { SERVICE_CARD } from '../service/store/app';
import useOrderStore from '../service/store/order';
import { URL_AGB } from '../utils/constants';
import { scrollToRef } from '../utils/scroll';

import './StepServiceSelect.scss';

const StepServiceSelect: FC = () => {
  const {
    setSelectedProduct,
    setOnlyAccessoriesSelected,
    setSelectedServiceCard
  } = useAppStore(state => state);
  const setProduct = useOrderStore(state => state.setProduct);
  const setOrderValue = useOrderStore(state => state.setValue);
  const increase = useAppStore(state => state.increase);
  const setStep = useAppStore(state => state.setStep);

  const handleClick = (value: string, cardType: SERVICE_CARD): void => {
    setOrderValue(value, 'service');
    setSelectedServiceCard(cardType);
    increase(1);
    scrollToRef();
  };

  const handleOnlyAccessoriesClick = (): void => {
    setOrderValue('Reparatur', 'service');
    setProduct(0, 'nur Zubehör');
    setSelectedProduct(undefined);
    setOnlyAccessoriesSelected(true);
    setSelectedServiceCard(SERVICE_CARD.ZUBEHOER);
    // see also the setStep function
    setStep(3);
    scrollToRef();
  };

  return (
    <div>
      <div className="service-card-warp">
        <ServiceCard
          hint="Nur Prüfung"
          image="inspektion.jpg"
          imageIcon="inspektion.svg"
          type="Inspektion"
          title="Inspektion/Erinnerungsservice"
          description="Lass' dein Pressgerät abholen, im Koffer oder im Karton."
          onClick={value => handleClick(value, SERVICE_CARD.INSPEKTION)}
        />
        <ServiceCard
          hint="Ich habe ein Problem"
          image="reparatur.jpg"
          imageIcon="reparatur.svg"
          type="Reparatur"
          title="Reparatur"
          description="Lass' dein Pressgerät abholen, im Koffer oder im Karton."
          onClick={value => handleClick(value, SERVICE_CARD.REPARATUR)}
        />
        <ServiceCard
          hint="Zubehör Service"
          image="reparatur.jpg"
          imageIcon="zubehoer.svg"
          type="Reparatur"
          title="Zubehör"
          description="Lass’ dein Zubehör abholen, im Koffer oder im Karton."
          onClick={handleOnlyAccessoriesClick}
        />
      </div>
      <div className="service-cards-info">
        Du willst ein Gerät mieten oder einen Vor-Ort-Service Beauftragen?<br />
        <a href="https://www.toolservice.de/" target="_top">Zur Service-Übersicht</a>
      </div>
      <div className="service-cards-legal">
        Hinweis: Dieses Formular wird von www.toolservice.de betrieben. Geräte von einigen Herstellern
        werden von unseren Partnerbetrieben bearbeitet. Mit der Benutzung dieses Formulars stimmen
        Sie unseren <a href={URL_AGB} target="_top" rel="noreferrer">AGBs</a> zu.
      </div>
    </div>
  );
};

export default StepServiceSelect;
